<script setup>
import { onBeforeUnmount, onMounted, provide, ref, watch } from "vue";
import { distance } from "../modules/geo.js";
import mapboxgl from "mapbox-gl";

const props = defineProps({
	center: {
		type: Array,
		default: () => [0, 0]
	},
	maxZoom: {
		type: Number,
		default: 22
	},
	minZoom: {
		type: Number,
		default: 0
	},
	src: {
		type: [Object, String],
		default: "mapbox://styles/mapbox/standard"
	},
	zoom: {
		type: Number,
		default: 0
	}
});
const emit = defineEmits(["load", "moveend"]);

const ready = ref(false);
const el = ref();
let map;

watch(() => props.center, (center, c) => map && distance(c, center) > 1000 ? map.flyTo({ center }) : map.easeTo({ center }));
watch(() => props.zoom, zoom => map && map.easeTo({ zoom }));

onMounted(() => {
	map = new mapboxgl.Map({
		container: el.value,
		center: props.center,
		zoom: props.zoom,
		style: props.src,
		minZoom: props.minZoom,
		maxZoom: props.maxZoom
	});

	map.addControl(new mapboxgl.ScaleControl());
	map.addControl(new mapboxgl.FullscreenControl());
	map.addControl(new mapboxgl.GeolocateControl({
		positionOptions: { enableHighAccuracy: true },
		fitBoundsOptions: { maxZoom: 16 },
		// showAccuracyCircle: false,
		showUserHeading: true,
		trackUserLocation: true
	}), "top-left");

	map.on("load", () => {
		ready.value = true;
		emit("load", map);
	});
	map.on("moveend", () => emit("moveend", map));

	provide("map", map);
});

onBeforeUnmount(() => map.remove());
</script>

<template>
	<div ref="el" class="vmap-map" v-bind="$attrs"/>
	<div v-if="ready" style="display: none">
		<slot/>
	</div>
</template>
